import { Ortak } from './../../../../providers/ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams, ViewController } from 'ionic-angular';
import { BllOrtak } from '../../../../providers/bll/bll-ortak';

/**
 * Generated class for the BirimeklePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-birimekle',
  templateUrl: 'birimekle.html',
})
export class BirimeklePage {
  birim:any={ID:-1,BirimName:""};
  birimdurum:any={};

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
      if (navParams.get("BirimVw") != null) {
        this.birimdurum = navParams.get("BirimVw");
        var data = new FormData();
        data.append("Birim_id", this.birimdurum.ID);
        this.bllOrtak.islem(data, "BirimGetirByID", "", false).then(a => {
          var Sonuc = <any>a;
          this.birim = Sonuc.SonucObject;
         
        }
        )
      }
  }

  ionViewDidLoad() {
   
  }
  boslukKontrol() {
    var mesaj = "";
    
    if (this.birim.BirimName == null || this.birim.BirimName == "") {
      mesaj = mesaj + "Lütfen Birim adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
   
    if (this.boslukKontrol()) {
      formData.append("Birim_json", JSON.stringify(this.birim));
     
      this.bllOrtak.islem(formData, "BirimEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
       

      })
    }
    this.cikis();
    }
    cikis()
    {
      this.viewCtrl.dismiss();
    }

}




// WEBPACK FOOTER //
// ./src/pages/Yonetim/BirimIslemleri/birimekle/birimekle.ts